/**
 * getEncodedImage function will request an image provided as an argument, and return
 * the base 64 representation of that image.
 * @param {string} imageUrl representing the resource we want to transform to base 64.
 * @returns a base 64 string for an image resource.
 */
const getEncodedImage = (imageUrl) => new Promise((resolve) => {
    fetch(imageUrl)
        .then(response => {
            if (!response.ok) {
                return null;
            }
            
            return response.blob();
        })
        .then(blob => {
            const reader = new FileReader();
            reader.onloadend = () => {
                resolve(reader.result);
            };
            reader.onerror = () => {
                resolve(null);
            };
            reader.readAsDataURL(blob);
        })
        .catch(() => {
            resolve(null);
        });
});

export default getEncodedImage;